module.exports = __webpack_public_path__ + "static/img/img50.df2b281.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/neighbourhood/img50.png
// module id = PH3p
// module chunks = 1